export default __webpack_public_path__ + "static/media/gallery_15.ec7bced9.jpg";